import {createContext, useContext, useEffect, useState} from 'react';
import {getAuth, onIdTokenChanged} from 'firebase/auth';

const AuthContext = createContext();

export function AuthProvider({children}) {
    const [user, setUser] = useState(undefined);
    const [authToken, setAuthToken] = useState(null);

    useEffect(() => {
        const auth = getAuth();

        const unsubscribe = onIdTokenChanged(auth, async (firebaseUser) => {
            if (firebaseUser) {
                const token = await firebaseUser.getIdToken();
                setAuthToken(token);
                setUser(firebaseUser);
            } else {
                setUser(null)
                setAuthToken(null);
            }
        });

        return () => unsubscribe();
    }, []);

    const isLoading = user === undefined;

    return (
        <AuthContext.Provider value={{user, authToken, isLoading}}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => {
    return useContext(AuthContext);
};
